import { kanbify } from '../lib/kanbifyClient'

/* ========== CARD MEMBERS ========== */
export async function addCardMember(cardId, userId, { cardTitle, senderName, actorId } = {}) {
    const { data, error } = await kanbify.rpc('add_card_member', { p_card_id: cardId, p_user_id: userId })
    const rpcError = error || (data?.success === false ? { message: data.error } : null)
    if (!rpcError && cardTitle) {
        // Trimite notificare email asincron (fire and forget)
        const { data: profile } = await kanbify.from('profiles').select('email, full_name').eq('id', userId).single()
        if (profile?.email) {
            kanbify.functions.invoke('send-notification', {
                body: {
                    type: 'card_assigned',
                    recipientId: userId,
                    recipientEmail: profile.email,
                    recipientName: profile.full_name,
                    actorId,
                    cardTitle,
                    cardId,
                    senderName,
                },
            }).catch(() => { /* notificarea email e opțională */ })
        }
    }
    return { error: rpcError }
}

// Completion fan-out is resolved by the backend from the active company.
// This includes primary and additional company memberships and avoids relying
// on whichever partial member list happens to be loaded in the browser.
export async function notifyCardCompleted({ cardId } = {}) {
    if (!cardId) return { success: false, error: 'cardId lipsă' }
    const { data, error } = await kanbify.rpc('notify_company_card_completed', { p_card_id: cardId })
    if (error || data?.success === false) {
        return { success: false, error: error?.message || data?.error || 'Notificarea nu a putut fi trimisă' }
    }
    return data
}

export async function removeCardMember(cardId, userId) {
    const { error } = await kanbify.from('card_members').delete().eq('card_id', cardId).eq('user_id', userId)
    return { error }
}
